module.exports = __webpack_public_path__ + "static/media/input.fe837872.svg";